import React, { useState, useEffect,useRef } from "react";
import { OuterContainer } from "../../EventCreation/styles";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import theme from "../../../assets/theme";
import {
  Paper,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Formik } from "formik";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { SecondaryCTAButton, PrimaryCTAButton } from "../../common/Buttons";
import { FormLabel } from "../../common/FormInputs";
import { AddCircleOutline } from "@material-ui/icons";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import useLoader from "../../../hooks/useLoader";
import { navigate } from "@reach/router";
import _ from "lodash";

var icons = ReactQuill.Quill.import("ui/icons");
icons[
  "bold"
] = `<img src=${require("../../../assets/images/editor/bold.svg")} aria-hidden="true" />`;
icons[
  "italic"
] = `<img src=${require("../../../assets/images/editor/italics.svg")} aria-hidden="true" />`;
icons[
  "underline"
] = `<img src=${require("../../../assets/images/editor/underline.svg")} aria-hidden="true" />`;
icons[
  "blockquote"
] = `<img src=${require("../../../assets/images/editor/blockQuote.svg")} aria-hidden="true" />`;
icons["align"][
  ""
] = `<img src=${require("../../../assets/images/editor/leftAlign.svg")} aria-hidden="true" />`;
icons["align"][
  "center"
] = `<img src=${require("../../../assets/images/editor/centerAlign.svg")} aria-hidden="true" />`;
icons["align"][
  "right"
] = `<img src=${require("../../../assets/images/editor/rightAlign.svg")} aria-hidden="true" />`;

const modules = {
  toolbar: [
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      "bold",
      "italic",
      "underline",
      "blockquote",
      "link",
      "image",
    ],
  ],
};

const EmailTemplates = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const [items, setItems] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const [clickedButton, setClickedButton] = useState("");
  const quillRefs = useRef([]);


  const [menuItems, setMenuItems] = useState([
    { label: "Event Name", value: "eventName" },
    { label: "Event Date", value: "eventDate" },
    { label: "Event Time", value: "eventDate" },
    { label: "Event Title", value: "eventTitle" },
    { label: "Event Duration", value: "eventDuration" },
    { label: "Event Description", value: "eventDescription" },
    { label: "Event Link", value: "eventLink" },
    { label: "Gallery View Link", value: "Gallery View Link" },
    { label: "Microsite Link", value: "Microsite Link" },
  ]);

  const initialState = {
    subjectLine: "",
    insertField: "",
    markInCC: "",
    emailTemplateMapping: "",
    calendarInvite: "",
    comment: "",
  };

  /*
  
  const inputs = [
    {
      name: "subjectLine",
      label: "Subject Line",
      type: "text",
      placeholder: "Enter subject line",
    },
    {
      name: "insertField",
      label: "Insert Field",
      type: "select",
      menuItems: menuItems,
      placeholder: "Enter insert field",
    },
    {
      name: "markInCC",
      label: "Mark in CC",
      type: "text",
      placeholder: "Enter mark in cc",
    },
    {
      name: "emailTemplateMapping",
      label: "Email Template Mapping",
      type: "select",
      menuItems: [
        { label: "Registration", value: "registration" },
        { label: "Reminder", value: "reminder" },
        { label: "Calendar", value: "calendar" },
        { label: "Thank you", value: "thankyou" },
      ],
    },
    {
      name: "calendarInvite",
      label: "Send as Calendar Invite",
      type: "switch",
    },
  ];

  */

  const custom_buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  const addCommentItems = (values, setFieldValue) => {
    const new_email_items = [
      ...values?.items,
      {
        subjectLine: "",
        insertField: "",
        markInCC: "",
        emailTemplateMapping: "",
        calendarInvite: "",
        comment: "",
      },
    ];
    setFieldValue("items", new_email_items);
  };

  const deleteCommentItems = (index, values, setFieldValue) => {
    const new_email_items = [...values?.items].filter(
      (ci, idx) => idx !== index,
    );
    setFieldValue("items", new_email_items);
  };

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "emailtemplates");
        setItems(response);
        if (Object.keys(response?.insertField).length !== 0) {
          setMenuItems([
            ...menuItems,
            ...Object.entries(response?.insertField)
              .filter((field) => field[1] === true)
              .map((item) => ({
                label: _.startCase(item[0]),
                value: item[0],
              })),
          ]);
        }
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        window.scrollTo(0, 0);
        setLoader({ state: false });
      }
    }
    if (id?.id) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "emailtemplates");
      setItems(response);
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description Email Template submit function
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        emailTemplates: values?.items,
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        navigate(`/dashboard/eventmanager/feedback/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "additional_tabs":
        id?.id
          ? navigate(`/dashboard/eventmanager/additional-tabs/${id?.id}`)
          : navigate(`/dashboard/eventmanager/additional-tabs`);
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  // const updateComment = (str, newText, setFieldValue, name) => {
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(str, "text/html");

  //   // 2. Get all elements in the body
  //   const elements = Array.from(doc.body.children);

  //   // 3. Get the last element (could be <p>, <div>, etc.)
  //   const lastEl = elements[elements.length - 1];

  //   if (lastEl) {
  //     let target = lastEl;
  //     while (target.lastElementChild) {
  //       target = target.lastElementChild;
  //     }

  //     // 5. Append text to the textContent of the innermost tag
  //     target.textContent += newText;

  //     // 6. Get updated HTML
  //     const updated = doc.body.innerHTML;

  //     setFieldValue(name, updated);
  //   } else {
  //     setFieldValue(name, newText);
  //   }
  //   // 4. If it has children (like <strong>), go deep inside the last child
  // };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
              "Event Manager",
              "Additional Tabs",
              "Email Templates",
              items?.eventName
                ? `${items?.eventName} (${items?.eventDate})`
                : "",
            ]
            : ["Event Manager", "Additional Tabs", "Email Templates"]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            items: items?.emailTemplates?.length
              ? items?.emailTemplates?.map((item) => ({
                ...item,
                subjectLine: item?.subjectLine,
                insertField: item?.insertField,
                markInCC: item?.markInCC,
                emailTemplateMapping: item?.emailTemplateMapping,
                calendarInvite: item?.calendarInvite,
                comment: item?.comment,
              }))
              : [initialState],
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
            handleSubmit,
            resetForm,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Email Template</Heading>
                  {values?.items?.map((arr, index) => (
                    <Paper
                      key={index}
                      elevation={3}
                      style={{
                        padding: 16,
                        border: "1px solid #e1e3ee",
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <Grid container item xs={12} spacing={3} style={{ padding: 16 }}>
                        {[
                          {
                            name: "subjectLine",
                            label: "Subject Line",
                            type: "text",
                            placeholder: "Enter subject line",
                          },
                          {
                            name: "insertField",
                            label: "Insert Field",
                            type: "select",
                            menuItems: menuItems,
                            placeholder: "Enter insert field",
                          },
                          {
                            name: "markInCC",
                            label: "Mark in CC",
                            type: "text",
                            placeholder: "Enter mark in cc",
                          },
                          {
                            name: "emailTemplateMapping",
                            label: "Email Template Mapping",
                            type: "select",
                            menuItems: [
                              { label: "Registration", value: "registration" },
                              { label: "Reminder", value: "reminder" },
                              { label: "Calendar", value: "calendar" },
                              { label: "Thank you", value: "thankyou" },
                            ],
                          },
                          {
                            name: "calendarInvite",
                            label: "Send as Calendar Invite",
                            type: "switch",
                            disabled: arr["emailTemplateMapping"] !== "calendar",
                          },
                        ].map((item, idx) => (
                          <Grid
                            item
                            xs={isBigScreen ? 4 : 12}
                            key={`items[${index}].${item.name}`}
                            style={styles.gridItem}
                          >
                            <FormField
                              {...{
                                item,
                                values,
                                errors,
                              }}
                              disabled={item.disabled}
                              menuItems={item.menuItems}
                              value={arr[item.name]}
                              name={`items[${index}].${item.name}`}
                              touched={`items[${index}].${item.name}`}
                              direction={"row"}
                              handleChange={(e) => {
                                const fieldName = item.name;

                                if (fieldName === "emailTemplateMapping") {
                                  setFieldValue(`items[${index}].${fieldName}`, e.target.value);

                                  setFieldValue(
                                    `items[${index}].calendarInvite`,
                                    e.target.value === "calendar"
                                  );
                                } else if (fieldName === "calendarInvite") {
                                  setFieldValue(
                                    `items[${index}].${fieldName}`,
                                    e.target.checked
                                  );
                                } else if (fieldName === "insertField") {
                                  setFieldValue(`items[${index}].${fieldName}`, e.target.value);

                                  const quillEditor = quillRefs.current[index]?.getEditor?.();
                                  if (quillEditor) {
                                    const cursorPos = quillEditor.getSelection()?.index || 0;
                                    const insertText = `{{${_.startCase(e.target.value)}}}`;
                                    quillEditor.insertText(cursorPos, insertText);
                                    setFieldValue(`items[${index}].comment`, quillEditor.root.innerHTML);
                                  }
                                }
                                else {
                                  setFieldValue(
                                    `items[${index}].${fieldName}`,
                                    e.target.value
                                  );
                                }
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                      <Grid>
                        <FormLabel
                          style={{
                            fontFamily: theme.fonts.primaryFontSemiBold,
                            color: "#A6AEBF",
                            marginLeft: "32px",
                          }}
                        >
                          Email content
                        </FormLabel>
                        <CommentContainer>
                          <EditorContainer>
                            <ReactQuill
                              ref={(el) => (quillRefs.current[index] = el)}
                              value={arr.comment}
                              id={`items[${index}].comment`}
                              name={`items[${index}].comment`}
                              onChange={(text) =>
                                setFieldValue(
                                  `items[${index}].comment`,
                                  text === "<p><br></p>" ? "" : text
                                )
                              }
                              modules={modules}
                              placeholder="Type here…"
                            />
                          </EditorContainer>
                        </CommentContainer>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          textAlign: "left",
                          marginTop: "20px",
                        }}
                      >
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            deleteCommentItems(index, values, setFieldValue)
                          }
                        >
                          Delete
                        </PrimaryCTAButton>
                      </Grid>
                    </Paper>
                  ))}
                  <ButtonWrapper>
                    <SecondaryCTAButton
                      onClick={() => addCommentItems(values, setFieldValue)}
                      style={{ paddingLeft: 0 }}
                    >
                      <AddCircleOutline
                        style={{ marginRight: "10px", marginLeft: "5px" }}
                      />
                      Add More Templates
                    </SecondaryCTAButton>
                  </ButtonWrapper>
                  <FormControl>
                    <ButtonContainer>
                      {custom_buttons.map((button, i) => (
                        <PrimaryCTAButton
                          key={i}
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            handleButtonClick(button, resetForm, handleSubmit)
                          }
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </ButtonContainer>
                  </FormControl>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );

};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default EmailTemplates;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const EditorContainer = styled.div`
  width: 95%;
  & .rdw-editor-wrapper,
  .ql-editor,
  .ql-container {
    background-color: #f9f9f9;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border: none;
    font-family: ${theme.fonts.primaryFontRegular};
  }
  .ql-editor {
    padding: 16px 16px;
    height: 180px;
  }
  & .rdw-editor-toolbar,
  .ql-toolbar {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #f4f6ff;
    border: none;
    & button {
      padding: 0;
    }
  }
  & .rdw-option-wrapper {
    background-color: transparent;
    border: 1px solid transparent;
    &:hover {
      box-shadow: none;
    }
  }
  & .ql-active {
    box-shadow: none;
    border: 1px solid rgb(200, 210, 220) !important;
  }
  & .rdw-editor-main {
    padding: 0 17px 10px;
    font-family: ${theme.fonts.primaryFontRegular};
  }
  & .public-DraftEditorPlaceholder-root,
  & .quill > .ql-container > .ql-editor.ql-blank::before {
    font-family: ${theme.fonts.primaryFontSemiBold};
    font-size: 14px;
    color: #acb1c2;
    font-style: normal;
  }
  & .blockquote .rdw-option-wrapper {
    content: "";
  }
  & .ql-toolbar.ql-snow {
    padding: 12px 12px 16px;
    .ql-formats button {
      margin-right: 60px;
    }
    .ql-align {
      outline: none;
    }
  }
`;

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;

export const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 125px;
`;

const CommentContainer = styled.div`
  width: 95%;
  display: flex;
  margin: 15px;
`;
